export function getLang() {
  const lang = navigator.language.toLowerCase().replace(/_/g, '-');

  if (lang === 'zh-tw' || lang === 'zh-hk' || lang.includes('zh-hant')) {
    return 'zh_TW';
  }

  if (lang === 'zh-cn' || lang.includes('zh-hans')) {
    return 'zh_CN';
  }

  return 'en';
}

export async function loadTranslations(lang: ReturnType<typeof getLang>) {
  const translationImportMap = {
    en: () => import('./locales/en.json'),
    zh_TW: () => import('./locales/zh_TW.json'),
    zh_CN: () => import('./locales/zh_CN.json'),
  };
  return await translationImportMap[lang]();
}

export function $(selector: string) {
  return document.querySelector(selector);
}

export function $$(selector: string) {
  return document.querySelectorAll(selector);
}
